import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AddExperienceComponent } from './components/add-experience/add-experience.component';
import { AddEducationComponent } from './components/add-education/add-education.component';
import { AddSkillsComponent } from './components/add-skills/add-skills.component';
import { AddLanguagesComponent } from './components/add-languages/add-languages.component';
import { AddOptionsComponent } from './components/add-options/add-options.component';
import { AddPaymentComponent } from './components/add-payment/add-payment.component';
import { AddSummaryComponent } from './components/add-summary/add-summary.component';
import { AddCertificatesComponent } from './components/add-certificates/add-certificates.component';
import { AddAccomplishmentsComponent } from './components/add-accomplishments/add-accomplishments.component';
import { AddHobbiesComponent } from './components/add-hobbies/add-hobbies.component';
import { AddOthersComponent } from './components/add-others/add-others.component';
import { ResumeInfoComponent } from './components/resume-info/resume-info.component';
import { AddProjectsComponent } from './components/add-projects/add-projects.component';

import { DonateComponent } from './components/donate/donate.component';

const routes: Routes = [
  { path: '',  component: AddExperienceComponent },
  { path: 'exp',  component: AddExperienceComponent },
  { path: 'edu',  component: AddEducationComponent },
  { path: 'skill',  component: AddSkillsComponent },
  { path: 'lang',  component: AddLanguagesComponent },
  { path: 'options', component: AddOptionsComponent },
  { path: 'payment', component: AddPaymentComponent },
  { path: 'summary', component: AddSummaryComponent },
  { path: 'certificates', component: AddCertificatesComponent },
  { path: 'accomplishments', component: AddAccomplishmentsComponent },
  { path: 'hobbies', component: AddHobbiesComponent },
  { path: 'others', component: AddOthersComponent },
  { path: 'info', component: ResumeInfoComponent },
  { path: 'projects', component: AddProjectsComponent },
  { path: 'donate', component: DonateComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResumeRoutingModule { }
